export default "__VITE_ASSET__BURfTYJ4__"